import { RequestBuilder, authorizedPipe } from 'services/net'
import { LEGACY_URL } from 'config'
import { ContentType } from 'shared'

export const V1 = Object.freeze({
  postedAction: function () {
    return function (
      action: 'archive' | 'unarchive' | 'favorite' | 'unfavorite',
      ids: string[],
      ppids: string[],
      all?: boolean,
      bucketId?: string,
      query?: string,
      types?: ContentType[]
    ) {
      const builder = new RequestBuilder(`${LEGACY_URL}/v3/posts/new_actions/${action}`).asPost().expectJSON()
      const data: any = {
        pp_page_ids: ppids,
        type: 'posted'
      }

      if (bucketId) {
        data.bucket_id = bucketId
      }

      if (all) {
        data.selected = 'all'
        data.post_ids = []
      } else {
        data.post_ids = ids
      }
      if (query) {
        data.search = query
      }
      if (types) {
        data.post_types = types.join(',')
      }

      return authorizedPipe<any>(builder.body(data).build())
    }
  }()
})
